import React from 'react';
import styled from 'styled-components';
import { Checkbox, FormControlLabel } from '@mui/material';
import { checkboxSx } from './formStyles';
import { FORM } from './formStyles';

const CheckboxGrid = styled.div<{ $columns?: 1 | 2 | 3 }>`
  display: grid;
  grid-template-columns: repeat(${({ $columns = 3 }) => $columns}, 1fr);
  gap: 8px 16px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

interface CheckboxOption {
  name: string;
  label: string;
  checked: boolean;
}

interface FormCheckboxGroupProps {
  options: CheckboxOption[];
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  columns?: 1 | 2 | 3;
}

export const FormCheckboxGroup: React.FC<FormCheckboxGroupProps> = ({
  options,
  onChange,
  columns = 3,
}) => (
  <CheckboxGrid $columns={columns}>
    {options.map((opt) => (
      <FormControlLabel
        key={opt.name}
        control={
          <Checkbox
            name={opt.name}
            checked={opt.checked}
            onChange={onChange}
            size="small"
            sx={checkboxSx}
          />
        }
        label={opt.label}
        sx={{
          margin: 0,
          padding: '6px 10px',
          borderRadius: FORM.fieldRadius,
          border: `1px solid ${FORM.border}`,
          '&:hover': { backgroundColor: FORM.surface },
        }}
      />
    ))}
  </CheckboxGrid>
);

interface FormCheckboxProps {
  name: string;
  label: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const FormCheckbox: React.FC<FormCheckboxProps> = ({ name, label, checked, onChange }) => (
  <FormControlLabel
    control={
      <Checkbox name={name} checked={checked} onChange={onChange} size="small" sx={checkboxSx} />
    }
    label={label}
  />
);
